import * as React from 'react'
import { Translations } from '../../../shared/i18n/Translations'
import type { CommonDeps } from '../base/CommonDeps'
import type { RenderCachedImage } from '../image/WithCachedImage'
import { GuideParentInfo } from './GuideParentInfo'
import type { ParentInfo } from './Model'

interface GuidePresentationWithParentInfoProps {
    deps: CommonDeps
    guideParentInfo: ParentInfo[]
    renderCachedImage: RenderCachedImage
    onClickGuideParentInfo: (parentInfo: ParentInfo) => void
}

export function GuidePresentationWithParentInfo(props: React.PropsWithChildren<GuidePresentationWithParentInfoProps>) {
    return (
        <>
            <div className="AppCore__guide__GuidePresentationParents">
                <div className="AppCore__guide__GuidePresentationParents-header">
                    {Translations.t('appcore:ElementGuide.guideParentInfo.heading')}
                </div>
                {props.guideParentInfo && (
                    <GuideParentInfo
                        deps={props.deps}
                        parentInfo={props.guideParentInfo}
                        renderCachedImage={props.renderCachedImage}
                        onClickGuideParentInfo={props.onClickGuideParentInfo}
                    />
                )}
            </div>
            {props.children}
        </>
    )
}
